import { render, staticRenderFns } from "./InvoiceShipper.vue?vue&type=template&id=683c1a7c&"
import script from "./InvoiceShipper.vue?vue&type=script&lang=js&"
export * from "./InvoiceShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports